<app-slider></app-slider>
<app-about></app-about>
<!-- <app-cta-contact></app-cta-contact> -->
<app-cta-one></app-cta-one>
<app-solutions></app-solutions>
<app-productivity></app-productivity>
<!-- <app-blog></app-blog> -->
<app-contact></app-contact>
